import React from 'react';
import { makeStyles, useTheme, } from '@material-ui/core/styles';
import {
  useMediaQuery,
  Box,
  Grid,
  Typography,
} from '@material-ui/core';
import BusinessIcon from '@mui/icons-material/Business';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SettingsIcon from '@mui/icons-material/Settings';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#212121',
    // minHeight: '40vh',
    padding: 20,
  },
  rootMobile: {
    flexGrow: 1,
    backgroundColor: '#212121',
    // minHeight: '40vh',
    // padding: 20,
  },
  paper: {
    padding: 20,
    color: '#FFF',
    textAlign: 'start',
    display: 'flex',
    justifyContent: 'center'
  },
  paperMobile: {
    padding: 28,
    color: '#FFF',
    textAlign: 'start',
    display: 'flex'
  },
  gridFlex: {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
    textAlign: 'center',
    color: '#FFF',
  },
  gridUnFlex: {
    padding: theme.spacing(2),
    color: '#FFF',
    fontSize: 10,
  },
  title: {
    flexGrow: 5,
  },
  titles: {
    flexGrow: 1,
  },
  titleUnflex: {
    fontSize: 25,
    right: 0,
    position: 'abosolute',
  },
  titlesUnflex: {
    flexGrow: 1,
    fontSize: 25,
  },
  emailTextField: {
    backgroundColor: "#FFF",
    width: '100%',
    borderRadius: 10,
  },
  gridFlexBottom: {
    display: 'flex',
    flexDirection: 'row',
    padding: 17,
    // padding: theme.spacing(2),
    color: '#FFF',
    width: '100%',
  },
  gridUnFlexBottom: {
    padding: theme.spacing(2),
    color: '#FFF',
    fontSize: 10,
    width: '100%',
  },
  icons: {
    marginRight: '20px'
  },
  gridIsMobile: {
    maxWidth: '100%'
  },
  gridContainer: {
    maxWidth: '100%'
  },
  textInfoLarge: {
    fontSize: '1.2rem'
  },
  textInfo: {
    fontSize: '1rem'
  }
}));

export default function CenteredGrid() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('md'));
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <div className={isMobile ? classes.root : classes.rootMobile}>
      <Grid className={classes.gridContainer} container spacing={2}>
        <Box className={isMobile ? classes.gridFlexBottom : classes.gridUnFlexBottom}>
          <Grid className={classes.gridIsMobile} item xs={12} sm={3}>
            <Box className={isMobile ? classes.paper : classes.paperMobile}>
              <BusinessIcon className={classes.icons} />
              <Typography className={isDesktopSmall ? classes.textInfo : classes.textInfoLarge}>
                InstoreX ApS
              </Typography>
            </Box>
          </Grid>
          <Grid className={classes.gridIsMobile} item xs={12} sm={3}>
            <Box className={isMobile ? classes.paper : classes.paperMobile}>
              <PhoneIcon className={classes.icons} />
              <Typography className={isDesktopSmall ? classes.textInfo : classes.textInfoLarge}>
                +45 70 60 59 49
              </Typography>
            </Box>
          </Grid>
          <Grid className={classes.gridIsMobile} item xs={12} sm={3}>
            <Box className={isMobile ? classes.paper : classes.paperMobile}>
              <EmailIcon className={classes.icons} />
              <Typography className={isDesktopSmall ? classes.textInfo : classes.textInfoLarge}>
                kontakt@instorex.dk
              </Typography>
            </Box>
          </Grid>
          <Grid className={classes.gridIsMobile} item xs={12} sm={3}>
            <Box className={isMobile ? classes.paper : classes.paperMobile}>
              <LocationOnIcon className={classes.icons} />
              <Typography className={isDesktopSmall ? classes.textInfo : classes.textInfoLarge}>
                Amalievej 6 1875 Frederiksberg C
              </Typography>
            </Box>
          </Grid>
          <Grid className={classes.gridIsMobile} item xs={12} sm={3}>
            <Box className={isMobile ? classes.paper : classes.paperMobile}>
              <SettingsIcon className={classes.icons} />
              <Typography className={isDesktopSmall ? classes.textInfo : classes.textInfoLarge}>
                CVR 41503262
              </Typography>
            </Box>
          </Grid>
        </Box>
      </Grid>
    </div>
  );
}